<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div v-if="type != 'save'">
        <span>客户编码：</span>
        <span>{{ form.bizNo }}</span>
      </div>
    </div>

    <el-form ref="form" :rules="rules" :model="form" label-width="120px" label-position="right">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="客户名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="客户简称">
            <el-input v-model="form.customerAbbrev" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="联系人" prop="ownerName">
            <el-input v-model="form.ownerName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="联系方式" prop="ownerContact">
            <el-input
              v-model="form.ownerContact"
              oninput="value=value.replace(/[^\d-]/g,'')"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="收货地址" :required="true">
            <area-select
              v-if="isInitArea"
              v-model="selectedArea"
              :data="$pcaa"
              :level="2"
              @change="handleArea"
            ></area-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="详细地址" prop="locDetails">
            <el-input v-model="form.locDetails" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="发票抬头">
            <el-input
              v-model="form.businessInformationName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="纳税人识别号">
            <el-input
              v-model="form.taxpayerRegNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="注册地址">
            <el-input
              v-model="form.registeAddress"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="电话">
            <el-input
              v-model="form.phone"
              oninput="value=value.replace(/[^\d-]/g,'')"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="3"
              maxlength="300"
              v-model="form.remark"
              placeholder="300字以内"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">收款账户</div>
          <el-button class="line-button" icon="el-icon-plus" @click="handleAddRow">新增</el-button>
        </div>
      </div>

      <TablePublic
        :colLists="colLists"
        :tableData="form.bankList"
        :paginationFlag="false"
        :nonMargin="true"
      >
        <template slot="solts" slot-scope="scope">
          <el-button class="delbutton" type="text" size="small" @click="handleDelRow(scope.index)">删除</el-button>
        </template>
        <template slot="bankName" slot-scope="scope">
          <el-form-item
            :prop="'bankList.' + scope.index + '.bankName'"
            :rules="rules.bankName"
            :show-message="false"
          >
            <el-input v-model="scope.data.bankName" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
        <template slot="bankAccount" slot-scope="scope">
          <el-form-item
            :prop="'bankList.' + scope.index + '.bankAccount'"
            :rules="rules.bankAccount"
            :show-message="false"
          >
            <el-input v-model="scope.data.bankAccount" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
      </TablePublic>
    </el-form>
  </div>
</template>

<script>
import {
  getProcessFactory,
  modifyProcessFactory
} from '@/api/manage/process-factory'
import TablePublic from '@/components/tablePublic.vue'
export default {
  props: {
    type: {
      type: String,
      default() {
        return ''
      },
    },
  },
  components: {
    TablePublic,
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        bizNo: '',
        phone: '',
        customerAbbrev: '',
        provinceCode: '440000',
        cityCode: '440700',
        districtCode: '440705',
        locDetails: '',
        ownerName: '',
        ownerContact: '',
        remark: '',
        bankList: [],
        type: 1,
        businessInformationName: '',
        taxpayerRegNo: '',
        registeAddress: '',
      },
      colLists: [
        {
          prop: 'bankName',
          label: '开户行',
          isTrue: true,
          formSolt: true,
          align: 'left',
        },
        {
          prop: 'bankAccount',
          label: '银行账号',
          isTrue: true,
          formSolt: true,
          align: 'left',
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      rules: {
        name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        ownerName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        ownerContact: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        locDetails: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        bankName: [{ required: true, message: '请输入', trigger: 'blur' }],
        bankAccount: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      selectedArea: [], //默认广东江门新会会城街道
      isInitArea: false,
    }
  },
  methods: {
    async initArea(row) {
      let data = row || this.form
      this.selectedArea = [data.provinceCode, data.cityCode, data.districtCode]
      this.$nextTick(() => {
        this.isInitArea = true
      })
    },
    async handleArea(n) {
      if (n) {
        this.form.provinceCode = n[0]
        this.form.cityCode = n[1]
        this.form.districtCode = n[2]
      }
    },
    async getDetails(row) {
      if (row) {
        await this.initArea(row)
        getProcessFactory({ id: row.id })
          .then((res) => {
            if (res.flag) {
              let data = res.data
              this.form = Object.assign(this.form, {
                ...data
              })
            } else {
              this.$message.error(res.message)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    handleAddRow() {
      this.form.bankList.push({
        bankName: '',
        bankAccount: '',
      })
    },
    handleDelRow(index) {
      this.form.bankList.splice(index, 1)
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            this.form.cnProvinceName = this.codeToText('area', this.form.provinceCode, '86')
            this.form.cnCityName     = this.codeToText('area', this.form.cityCode, this.form.provinceCode)
            this.form.cnDistrictName = this.codeToText('area', this.form.districtCode, this.form.cityCode)

            let result = await modifyProcessFactory(this.form, this.type)
            if (result.code == 200 && result.flag) {
              this.$message.success(`${this.type == 'edit' ? '修改' : '提交'}成功`)
              resolve()
            } else {
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    codeToText(fieldName, code, parentCode) {
      let name = ''
      switch (fieldName) {
        case 'area':
          for (let keyCode in this.$pcaa[parentCode]) {
            if (code == keyCode) {
              name = this.$pcaa[parentCode][keyCode]
              break
            }
          }
          return name
      }
    },
    reset() {
      // this.form = {
      //   id: '',
      //   name: '',
      //   bizNo: '',
      //   remark: '',
      // }
      // this.isInitArea = false
      // this.resetForm('form')
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item.is-error .fieldCode .el-input__inner,
.el-form-item.is-error .fieldCode .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}
.left {
  margin-left: 10px;
}
/deep/ .area-select.medium {
  width: 130px;
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.area-select {
  height: 38px;
}
</style>